import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INTENSITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Intensity.Name')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const INTENSITY_CONFIG = {
  entityName: 'Intensity',
  localizationKey: 'Planning::Entity.Intensity',
  fields: INTENSITY_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.Intensities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
